import { Component, prop } from "@kluntje/core";
import { HIDDEN } from "Helper/cssClasses";
import { getDocLang } from "Helper/metaHelper";
import ConsentManagementService from "Services/ConsentManagementService";

/**
 * Custom Element to integrate sherpa travel restrictions
 */
class FRASherpa extends Component {
  static UC_SERVICE_NAME = "Sherpa";

  // props are optional. but if one is set, all should be set.
  // e.g. having a flight with date but no destination makes no sense. and sherpa will warn
  @prop({ required: true })
  departureDate = "";

  // airport code for the flights origin
  @prop({ required: true })
  origin = "";

  // airport code for the flights destination
  @prop({ required: true })
  destination = "";

  constructor() {
    super({
      ui: {
        consentHint: ".fra-m-sherpa__consent-hint :-one",
        setConsentBtn: ".fra-js-sherpa__set-consent :-one",
        showConsentLayerBtn: ".fra-js-sherpa__show-consent-layer :-one",
      },
      events: [
        {
          event: "click",
          target: "setConsentBtn",
          handler: "setConsent",
        },
        {
          event: "click",
          target: "showConsentLayerBtn",
          handler: "showConsentLayer",
        },
      ],
    });
  }

  /**
   * @override
   */
  async afterComponentRender() {
    if (!(await ConsentManagementService.hasConsent(FRASherpa.UC_SERVICE_NAME))) {
      this.ui.consentHint.classList.remove(HIDDEN);
    }

    // SDK already loaded
    if ("$sherpa" in window) this.initializePlugin();
    else {
      window.onSherpaEvent = () => {
        this.initializePlugin();
      };
    }
  }

  initializePlugin() {
    const lang = getDocLang().toLocaleLowerCase().substring(0, 2);

    const elementConfig: {
      placement: string;
      language: string;
      segments?: Array<Record<string, any>>;
      travellers: Array<{ nationality: string }>;
    } = {
      placement: "discovery",
      language: lang,
      // there is no information regarding users nationality, therefor we use the more common one
      travellers: [{ nationality: "DEU" }],
    };

    if (this.departureDate) {
      Object.assign(elementConfig, {
        segments: [
          // Outbound Segment
          {
            segmentType: "OUTBOUND",
            origin: {
              airportCode: this.origin,
            },
            destination: {
              airportCode: this.destination,
            },
            departureDate: this.departureDate,
            departureTime: "12:59:00",
          },
        ],
      });
    }

    window.$sherpa.V2.createElement("trip", elementConfig).mount("#sherpa-trip-element");
  }

  setConsent() {
    ConsentManagementService.setConsent(FRASherpa.UC_SERVICE_NAME);
  }

  showConsentLayer() {
    ConsentManagementService.showConsentLayer(FRASherpa.UC_SERVICE_NAME);
  }
}

customElements.define("fra-m-sherpa", FRASherpa);

export default FRASherpa;
